import { render, staticRenderFns } from "./surface_posts.vue?vue&type=template&id=75e1a5e0&"
import script from "./surface_posts.vue?vue&type=script&lang=js&"
export * from "./surface_posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports